import { createSelector } from '@reduxjs/toolkit';
import { initialState } from './slice';
import { RootState } from 'newTypes';

const selectDomain = (state: RootState) => {
  if (state && state.questionListState) {
    return state.questionListState;
  } else {
    return initialState;
  }
};
export const selectList = createSelector([selectDomain], (state) => state.list);
export const selectQueByIdList = createSelector([selectDomain], (state) => state.queByIdList);
export const selectListAll = createSelector([selectDomain], (state) => state.listAll);
export const selectForm = createSelector([selectDomain], (state) => state.form);
export const selectEditindex = createSelector([selectDomain], (state) => state.editIndex);
export const SelectLoading = createSelector([selectDomain], (state) => state.loading);
export const SelectPageNo = createSelector([selectDomain], (state) => state.pageNo);
export const SelectPageSize = createSelector([selectDomain], (state) => state.pageSize);
export const SelectTotalRow = createSelector([selectDomain], (state) => state.totalRow);
export const SelectSearch = createSelector([selectDomain], (state) => state.search);
export const selectHandleChange = createSelector([selectDomain], (state) => state.handleChange);
export const SelectSortDir = createSelector([selectDomain], (state) => state.sortDir);
export const SelectSortColumn = createSelector([selectDomain], (state) => state.sortColumn);
export const SelectMilestone = createSelector([selectDomain], (state) => state.milestone);
export const SelectMilestoneArray = createSelector([selectDomain], (state) => state.MilestoneArray);
export const selectMilestoneData = createSelector([selectDomain], (state) => state.milestoneData);
